<template>
  <div class="bd">
    <!-- 汽车废 -->
    <div class="mainitem">
      <div class="left" :style="'height:'+screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>产出物库存总计</div>
          </div>
          <div class="company-content">
            <div
              class="item-list"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>产能统计</div>
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
      dataList: [
        {
          title: "塑料白pp",
          content: "892Kg",
        },
        {
          title: "塑料颗粒",
          content: "100Kg",
        },
        {
          title: "橡胶盖",
          content: "100Kg",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
      });
    }, 200);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：Kg",
          left: "right",
          subtextStyle: {
            color: "#FFF",
            fontSize: "20",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + ":  " + params.percent + "%";
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          bottom: "bottom",
          textStyle: {
            fontSize:12,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "塑料白pp" },
              { value: 735, name: "塑料颗粒" },
              { value: 580, name: "橡胶盖" },
            ],
            label: {
              fontSize: 12,
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped lang="scss">
.mainitem {
  ::-webkit-scrollbar {
    width: 0px;
  }
  .left,
  .right {
    width: 23vw;
    height: 75vh;
    background: rgba(17,47,107, 0.6);
    overflow: hidden;
  }
  .left {
    float: left;
    margin-left: 20px;
    .left-content {
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      height: 50%;
      .company-content {
        line-height: 40px;
        font-size: 20px;
        height: 90%;
        // background: #fff;

        overflow-y: scroll;
        scroll-behavior: smooth;
        overscroll-behavior: contain;
        .item-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgb(200, 200, 200);
        }
      }
    }
  }
  .right {
    float: right;
    margin-right: 20px;
    .right-content {
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      height: 50%;
      .company-content {
        line-height: 40px;
        font-size: 20px;
        height: 90%;
        overflow-y: scroll;
        scroll-behavior: smooth;
        overscroll-behavior: contain;
        .item-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgb(200, 200, 200);
        }
      }
    }
  }

  .left .left-content .type-title,
  .right .right-content .type-title {
    font-size: 22px;
    margin-bottom: 10px;
    border-left: 6px rgb(115, 95, 250) solid;
    padding-left: 15px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* echarts */
  /* 汽废左侧饼图 */
  .left-echarts-1,
  .right-echarts-1 {
    width: 100%;
    height:80%;
  }
}
</style>
  